import { prop, ComponentEventBus, inject } from "fw";

@inject
export class Toggle {
    @prop(null) private label: string;
    @prop(null) private ariaLabel: string;
    @prop(null) private value: boolean;
    @prop(null) private validation;
    @prop(false) private readonly: boolean;
    @prop(false) private disabled: boolean;

    private $slots: { [key: string]: HTMLElement };

    constructor(private ceb: ComponentEventBus) {}

    get pValue() {
        return this.value;
    }

    set pValue(v) {
        this.ceb.updateModel(v);
        this.ceb.dispatch("update:value", v);
        this.ceb.dispatch("change", v);
    }

    public get hasTextBeforeSlot(): boolean {
        return !!this.$slots.textBefore;
    }
}
